import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function ImageField({ label, value, onChange, testId = "image-field" }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Immagine troppo grande (massimo 5 MB)");
      return;
    }
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/uploads", fd);
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };
  return (
    <div data-testid={testId}>
      <span className="nx-label">{label}</span>
      <div className="flex items-center gap-3">
        <div className="w-20 h-14 rounded-md border border-[#C6C6CE]/15 bg-[#050505] overflow-hidden shrink-0 flex items-center justify-center">
          {value ? <img src={value} alt="Anteprima" data-testid={`${testId}-preview`} className="w-full h-full object-cover" /> : <ImagePlus className="w-5 h-5 text-[#C6C6CE]/30" />}
        </div>
        <div className="flex-1 min-w-0 space-y-2">
          <div className="flex gap-2">
            <button type="button" data-testid={`${testId}-upload-button`} disabled={busy} onClick={() => input.current?.click()} className="btn-ghost btn-sm">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ImagePlus className="w-3.5 h-3.5" />} {busy ? "Caricamento..." : "Carica immagine"}
            </button>
            {value && <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange("")} className="btn-danger" aria-label="Rimuovi immagine"><X className="w-3.5 h-3.5" /></button>}
          </div>
          <input data-testid={`${testId}-url-input`} className="nx-input py-1.5 text-xs" placeholder="oppure incolla un link" value={value || ""} onChange={(e) => onChange(e.target.value)} />
        </div>
        <input ref={input} data-testid={`${testId}-file-input`} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
      </div>
      <p className="text-[10px] text-[#C6C6CE]/40 mt-1">JPG, PNG, WEBP o GIF · max 5 MB</p>
    </div>
  );
}
